var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"wrapCont"}},[_c('router-view'),(_vm.isConfirmPopupOpened)?_c('section',{staticClass:"backdrop",attrs:{"id":"check"}},[_c('confirm',{ref:"confirmPopup",on:{"close":_vm.onConfirmPopupClose}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }